import { render, staticRenderFns } from "./Scene3D.vue?vue&type=template&id=1ecd53e8&"
import script from "./Scene3D.vue?vue&type=script&lang=js&"
export * from "./Scene3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports